import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@/environments/environment';
import {Observable} from 'rxjs';
import {SeasonGroupedByCategory} from '@/app/core/models/bet/seasonGroupedByCategory';
import {Season} from '@/app/core/models/bet/season';

@Injectable({
	providedIn: 'root'
})
export class SeasonService {

	constructor(
		private readonly http: HttpClient
	) {}

	private readonly SERVICE_URI = `${environment.backendUrl}/season`;

	getAllSeasonsGroupedByCategory(): Observable<SeasonGroupedByCategory[]> {
		return this.http.get<SeasonGroupedByCategory[]>(`${this.SERVICE_URI}`);
	}

	getCurrentSeason(): Observable<Season> {
		return this.http.get<Season>(`${this.SERVICE_URI}/current`);
	}

	getYears(): Observable<number[]> {
		return this.http.get<number[]>(`${this.SERVICE_URI}/years`);
	}

}
